// extracted by mini-css-extract-plugin
export var baseButton = "_qf-0";
export var controlsArrowKeys = "_qf-1";
export var controlsResetButton = "_qf-2";
export var lightGameButton = "_qf-4 _qf-0";
export var playAgainButton = "_qf-5 _qf-0";
export var startGameButton = "_qf-3 _qf-0";